import Repository from '../Repository';

export default {

	getMaintenanceMode() {
		var response = Repository.get('Helper/GetMaintenanceMode', {
			params: {}			
		});
		return response;
	},

}
